// Floor Items - SVG Icon Functions
// Each function returns inline SVG markup for the respective icon.
// Usage: vcFloorIcons.get("icon-attic", "my-class")
var vcFloorIcons = (function () {

    var icons = {

        "icon-attic": function () {
            return '<path d="M32 6L4 30h8v24h40V30h8L32 6z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>' +
                '<path d="M12 30l20-18 20 18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
                '<line x1="20" y1="22" x2="20" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
                '<rect x="18" y="8" width="4" height="4" fill="currentColor" rx="1"/>';
        },

        "icon-floor": function () {
            return '<rect x="10" y="12" width="44" height="46" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>' +
                '<line x1="10" y1="32" x2="54" y2="32" stroke="currentColor" stroke-width="2"/>' +
                '<rect x="18" y="17" width="8" height="10" fill="none" stroke="currentColor" stroke-width="2" rx="1"/>' +
                '<rect x="38" y="17" width="8" height="10" fill="none" stroke="currentColor" stroke-width="2" rx="1"/>' +
                '<rect x="18" y="37" width="8" height="10" fill="none" stroke="currentColor" stroke-width="2" rx="1"/>' +
                '<rect x="38" y="37" width="8" height="10" fill="none" stroke="currentColor" stroke-width="2" rx="1"/>';
        },

        "icon-ground-floor": function () {
            return '<rect x="10" y="20" width="44" height="34" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>' +
                '<rect x="26" y="36" width="12" height="18" fill="none" stroke="currentColor" stroke-width="2" rx="1"/>' +
                '<circle cx="36" cy="46" r="1.5" fill="currentColor"/>' +
                '<rect x="16" y="26" width="8" height="8" fill="none" stroke="currentColor" stroke-width="2" rx="1"/>' +
                '<rect x="40" y="26" width="8" height="8" fill="none" stroke="currentColor" stroke-width="2" rx="1"/>' +
                '<line x1="4" y1="54" x2="60" y2="54" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>';
        },

        "icon-basement": function () {
            return '<line x1="4" y1="24" x2="60" y2="24" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>' +
                '<rect x="10" y="24" width="44" height="34" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>' +
                '<line x1="10" y1="24" x2="10" y2="58" stroke="currentColor" stroke-width="3"/>' +
                '<line x1="54" y1="24" x2="54" y2="58" stroke="currentColor" stroke-width="3"/>' +
                '<path d="M22 36h20M22 44h20M22 52h20" stroke="currentColor" stroke-width="2" stroke-linecap="round" opacity="0.6"/>' +
                '<path d="M28 18v6M36 18v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>';
        },

        "icon-outdoor": function () {
            return '<circle cx="50" cy="12" r="6" fill="none" stroke="currentColor" stroke-width="2"/>' +
                '<path d="M14 58c0-12 6-18 6-26s-4-14 4-20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
                '<path d="M20 40c4 0 8 2 12 2s8-2 12-2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
                '<path d="M10 50c6 0 10 3 16 3s10-3 16-3 10 3 14 3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
                '<line x1="20" y1="58" x2="20" y2="34" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>';
        },

        "icon-utility-room": function () {
            return '<rect x="8" y="14" width="48" height="40" rx="3" fill="none" stroke="currentColor" stroke-width="3"/>' +
                '<circle cx="32" cy="34" r="12" fill="none" stroke="currentColor" stroke-width="2.5"/>' +
                '<path d="M32 22v-4M32 46v4M20 34h-4M44 34h4M23.5 25.5l-3-3M40.5 42.5l3 3M23.5 42.5l-3 3M40.5 25.5l3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
                '<circle cx="32" cy="34" r="4" fill="currentColor"/>';
        },

        "icon-boiler-room": function () {
            return '<rect x="18" y="22" width="28" height="36" rx="3" fill="none" stroke="currentColor" stroke-width="3"/>' +
                '<path d="M24 8c0 4 4 6 0 12M32 8c0 4 4 6 0 12M40 8c0 4 4 6 0 12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
                '<line x1="18" y1="32" x2="46" y2="32" stroke="currentColor" stroke-width="2"/>' +
                '<circle cx="32" cy="44" r="5" fill="none" stroke="currentColor" stroke-width="2"/>' +
                '<circle cx="32" cy="44" r="2" fill="currentColor"/>';
        },

        "icon-thermal-area": function () {
            return '<path d="M12 54c8-4 12-14 12-22s4-16 8-22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
                '<path d="M24 54c8-4 12-14 12-22s4-16 8-22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
                '<path d="M36 54c8-4 12-14 12-22s4-16 8-22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
                '<rect x="6" y="52" width="52" height="6" rx="3" fill="none" stroke="currentColor" stroke-width="2"/>';
        },

        "icon-sauna": function () {
            return '<rect x="8" y="16" width="48" height="40" rx="4" fill="none" stroke="currentColor" stroke-width="3"/>' +
                '<line x1="8" y1="36" x2="56" y2="36" stroke="currentColor" stroke-width="2"/>' +
                '<line x1="8" y1="46" x2="56" y2="46" stroke="currentColor" stroke-width="2"/>' +
                '<path d="M20 10c0 2 2 3 0 6M32 10c0 2 2 3 0 6M44 10c0 2 2 3 0 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
                '<circle cx="18" cy="28" r="3" fill="currentColor" opacity="0.5"/>' +
                '<circle cx="32" cy="28" r="3" fill="currentColor" opacity="0.5"/>';
        }
    };

    function get(id, cssClass) {
        var fn = icons[id];
        if (!fn) return "";
        var cls = cssClass ? " class='" + cssClass + "'" : "";
        return "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'" + cls + ">" + fn() + "</svg>";
    }

    function list() {
        return Object.keys(icons);
    }

    return {
        get: get,
        list: list
    };

})();
